import { Injectable } from '@angular/core';
import { AuxiliarService } from '@appNeo/neoShared/services/auxiliar/auxiliar.service';
import { UtilidadesCrudService } from '@appNeo/neoShared/services/utilidades/utilidades-crud.service';
import { HttpClient } from '@node_modules/@angular/common/http';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { catchError, forkJoin, map, Observable, of } from 'rxjs';
import { IdTiposTurnosEnum, NombreTiposTurnosEnum, TiposTurnosColorEnum } from '@appNeo/core/global';

@Injectable({
  providedIn: 'root'
})
export class TiposTurnoService extends UtilidadesCrudService {

  constructor(
    http: HttpClient,
    public auxiliar: AuxiliarService,
  ) {
    super(
      http,
      auxiliar,
      'tiposTurno',
      'tiposTurno',
      'Tipos Turno',
      'Tipos Turnos',
      [
      ]
    );
  }

  getColor(idTipoTurno): string {
    return (TiposTurnosColorEnum[idTipoTurno]) ? TiposTurnosColorEnum[idTipoTurno] : '';
  }

  getColorFromTipoTurnoId(idTipoTurno: string): string | undefined {
    const key = Object.keys(IdTiposTurnosEnum).find(
      k => IdTiposTurnosEnum[k as keyof typeof IdTiposTurnosEnum] === idTipoTurno
    );

    if (key && key in TiposTurnosColorEnum) {
      return TiposTurnosColorEnum[key as keyof typeof TiposTurnosColorEnum];
    }

    return undefined;
  }

  getNameFromTipoTurnoId(idTipoTurno: string): string | undefined {
    const key = Object.keys(IdTiposTurnosEnum).find(
      k => IdTiposTurnosEnum[k as keyof typeof IdTiposTurnosEnum] === idTipoTurno
    );

    if (key && key in NombreTiposTurnosEnum) {
      return NombreTiposTurnosEnum[key as keyof typeof NombreTiposTurnosEnum];
    }

    return undefined;
  }

  /************************************ 
  * Funciones apoyo                  *
  *************************************/
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    let peticion = {};
    const id = route.params?.id;   
    if (id) {
      peticion['entidad'] = this.get(id).pipe(
        catchError(err => of(null))
      )
    }
    if (Object.keys(peticion).length > 0) {
      return forkJoin(peticion);
    } else {
      of(true);
    }
  }

}


